/**
 * @description Constantes para el manejo de los cursos
 * @param {number} APROBADO - 1 Estado aprobado
 * @param {number} RECHAZADO - 2 Estado rechazado
 * @param {number} REVISAR - 3 Estado revisar
 * @param {number} CANCELADO - 4 Estado cancelado
 * @param {number} CREADO - 5 Estado pendiente
 * @param {number} ATRASADO - 6 Estado atrasado
 */
export const STATUS_COURSE =Object.freeze( {
	"CREADO":5,
     "APROBADO":1,
     "RECHAZADO":2,
     "REVISAR":3,
	//  "POR_APROBAR":3,
     "CANCELADO":4,
     "ATRASADO":6,
     "EMPTY":0,
	get GET_EDIT() {
		return [
			this.APROBADO,
			this.CANCELADO,
			this.REVISAR,
			
		]
	},

})

export const MESES =Object.freeze( [
	{ id: 0, label: "Extra" },
	{ id: 1, label: "Enero" },
	{ id: 2, label: "Febrero" },
	{ id: 3, label: "Marzo" },
	{ id: 4, label: "Abril" },
	{ id: 5, label: "Mayo" },
	{ id: 6, label: "Junio" },
	{ id: 7, label: "Julio" },
	{ id: 8, label: "Agosto" },
	{ id: 9, label: "Septiembre" },
	{ id: 10, label: "Octubre" },
	{ id: 11, label: "Noviembre" },
	{ id: 12, label: "Diciembre" }
])

export const TARJETA_COLOR = Object.freeze({
  [STATUS_COURSE.APROBADO]: "#007F008d",
  [STATUS_COURSE.CANCELADO]: "#FF00008D",
  [STATUS_COURSE.ATRASADO]: "#FF99008D",
  [STATUS_COURSE.REVISAR]: "#0099ff8D",
  [STATUS_COURSE.CREADO]: "#9188888D",
  [STATUS_COURSE.RECHAZADO]: "#C757E98D",
[STATUS_COURSE.EMPTY]: "#FFFFFFE3",
});

export const STATUS_TEXT = Object.freeze({
  [STATUS_COURSE.APROBADO]: "Aprobado",
  [STATUS_COURSE.CANCELADO]: "Cancelado",
  [STATUS_COURSE.ATRASADO]: "Atrasado",
  [STATUS_COURSE.REVISAR]: "Por Aprobar",
  [STATUS_COURSE.CREADO]: "Creado",
  [STATUS_COURSE.RECHAZADO]: "Rechazado",
  [STATUS_COURSE.EMPTY]: "Sin Asignar",
});
